let audioFilesQueue = [],
	isAudioPlaying = false

window.addAudioFileToQueue = (data) => {
	console.info("Adding to queue", data.audioSrc)
	const audio = new Audio(data.audioSrc)

	audio.onended = () => {
		audioFilesQueue = audioFilesQueue.slice(1)
		if (audioFilesQueue.length > 0) audioFilesQueue[0].play()
	}

	audio.onplay = () => {
		if(data.messageId){
			const messageElement = global.window.document?.querySelector(`[data-for-id="${data.messageId}"]`)
			console.log("Playing audio for => ", messageElement.querySelector(".prose").innerText )
			// scroll to message element
			messageElement?.scrollIntoView({ behavior: "smooth" })
		}

	}
	audioFilesQueue.push(audio)

	if (audioFilesQueue.length === 1 && isAudioPlaying === true) {
		audio.setAttribute("data-message-id", data.messageId)
		audioFilesQueue[0].play()
	}
}

window.playAudio = () => {
	isAudioPlaying = true
	if (audioFilesQueue.length > 0) audioFilesQueue[0].play()
}

window.stopAudio = () => {
	isAudioPlaying = false
	if (audioFilesQueue.length > 0) audioFilesQueue[0].pause()
}
